<template>
  <div class="about">
    <b-container>
      <div class="page-title text-center py-5">
        <h1>About <span>us</span></h1>
      </div>
    </b-container>

    <b-container>
      <b-row class="mb-5 py-5">
        <b-col md="6" class="d-flex flex-column justify-content-center mb-5 mb-md-0">
          <div class="highlight__section-header">
            <div class="section-title">
              <h3>Roots in Vienna</h3>
            </div>
            <div class="section-blurb">
              <p>
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium,totam.
              </p>
              <p>
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium,totam. Rem aperiam, eaque ipsa
                quae ab illo inventore veritatis et quasi architecto beatae
                vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia
                voluptas sit aspernatur aut odit aut fugit.
              </p>
            </div>
          </div>
        </b-col>
        <b-col md="6" class="d-flex flex-column justify-content-center">
          <b-img center src="@/assets/logo.png" alt="Growth Labs logo" width="300px"></b-img>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mb-5">
      <b-row>
        <b-col md="6" class="d-flex flex-column justify-content-center">
          <b-img center fluid src="#" alt="Coach presenting"></b-img>
        </b-col>
        <b-col md="3" class="d-flex flex-column justify-content-center">
          <div class="highlight__box p-3 mb-5 mb-md-0">
            <h5>Our <span>mission</span></h5>
            <p>
              Lorem ipsum dolor sit amet,consectetur adipiscing elit.Mauris fermentum eleifend  semper. Mauris semper urna  eget tortor eleifend, id  sodales augue suscipit. Nunc  cursus tincidunt quam et  finibus. Integer pharetra ut  metus ut ornare.
            </p>
          </div>
        </b-col>
        <b-col md="3">
          <div class="highlight__box highlight__box-light p-3 mb-5">
            <h5>Our <span>vision</span></h5>
            <p>
              Lorem ipsum dolor sit amet,consectetur adipiscing elit.Mauris fermentum eleifend  semper. Mauris semper urna  eget tortor eleifend, id  sodales augue suscipit. Nunc  cursus tincidunt quam et  finibus. Integer pharetra ut  metus ut ornare.
            </p>
          </div>
          <div class="highlight__box highlight__box-dark p-3">
            <h5>Our <span>goal</span></h5>
            <p>
              Lorem ipsum dolor sit amet,consectetur adipiscing elit.Mauris fermentum eleifend  semper. Mauris semper urna  eget tortor eleifend, id  sodales augue suscipit. Nunc  cursus tincidunt quam et  finibus. Integer pharetra ut  metus ut ornare.
            </p>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid class="px-0">
      <div class="slim-banner">
        <FooterBanner></FooterBanner>
      </div>
    </b-container>
  </div>
</template>

<script>
import FooterBanner from "@/components/partials/FooterBanner";
export  default {
  name: "About",
  components: {
    FooterBanner
  }
}
</script>

<style lang="scss">
.page {
  &-title {
    h1 {
      &:before {
        content: "ABOUT";
      }
    }
  }
}

.slim-banner {
  background: $yellow;
}

</style>